import * as Yup from "yup";

export const approvalActionSchema = Yup.object().shape({
  note: Yup.string().nullable(),
});
